var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-item-wrap",on:{"click":_vm.showBigImage}},[_c('div',{staticClass:"img-item",style:({ backgroundImage: `url(${_vm.$setPicSize(_vm.picUrl)})` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }